import { Component, EventEmitter, Input, Output, Signal, ViewChild } from '@angular/core';
import {
  Agent,
  DietaryConsideration,
  DietaryConsiderationKeys,
  LayoutGridType,
  Messages,
} from '@ag-common-lib/public-api';
import { DxFormComponent } from 'devextreme-angular';
import { ModalWindowComponent } from '../../../modal-window/modal-window.component';
import { DietaryConsiderationService } from './dietary-considerations.service';
import { validateDxGroups } from 'ag-common-svc/lib/utils/validation';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'ag-shr-dietary-considerations',
  templateUrl: './dietary-considerations.component.html',
  styleUrls: ['./dietary-considerations.component.scss'],
  providers: [DietaryConsiderationService],
})
export class DietaryConsiderationsComponent {
  @Input('agent') set _agent(value: Agent) {
    this.agent = value;
    this.dietaryConsiderationFormDetails = this.dietaryConsiderationService.getFormData(value);
  }

  @Input() hasPermissionsToEdit: boolean = true;
  @Input() hasPermissionsToDelete: boolean = true;
  @Input() hasPermissionsToAdd: boolean = true;
  @Input() caption: string = 'Dietary Considerations';
  @Input() type: LayoutGridType = LayoutGridType.short;
  // eslint-disable-next-line
  @Output() onFieldsUpdated: EventEmitter<{ agentId: string; updates: Partial<Agent> }> = new EventEmitter();
  @ViewChild('dietaryConsiderationModalRef', { static: true }) dietaryConsiderationModalComponent: ModalWindowComponent;
  @ViewChild('dietaryConsiderationFormRef', { static: false }) dietaryConsiderationFormComponent: DxFormComponent;

  dietaryConsiderationFormDetails: DietaryConsideration;
  protected readonly DietaryConsiderationKeys = DietaryConsiderationKeys;
  protected readonly validationGroup = 'dietaryConsiderationValidationGroup';
  protected readonly LayoutGridType = LayoutGridType;
  protected readonly Messages = Messages;
  inProgress: Signal<boolean>;

  private agent: Agent;

  constructor(private dietaryConsiderationService: DietaryConsiderationService) {
    this.inProgress = toSignal(dietaryConsiderationService.inProgress$, { initialValue: false });
  }

  saveAgentUpdates = async () => {
    const isValid = await validateDxGroups(this.validationGroup);
    if (isValid) {
      const agentId = this.agent[BaseModelKeys.dbId];
      this.dietaryConsiderationService.handleSave(this.agent[BaseModelKeys.dbId]).then(updates => {
        this.dietaryConsiderationModalComponent.hideModal();
        this.onFieldsUpdated.emit({ agentId, updates });
      });
    }
  };

  showEditorModal = () => {
    this.dietaryConsiderationModalComponent.showModal();
  };

  handleClosePopup = this.dietaryConsiderationService.onCancelEdit;

  public get agentDbId(): string | null {
    return this.agent?.[BaseModelKeys.dbId] ?? null;
  }
}
